import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { isPasskeysEnabled } from '@/constant/features';
import { auth } from '@/services/auth';
import { passkeys } from '@/services/passkeys';

export const PASSKEYS_QUERY_KEY = ['passkeys'] as const;

/** The signed-in User's passkeys in this environment. Never includes public keys. */
export function usePasskeys() {
  return useQuery({
    queryKey: PASSKEYS_QUERY_KEY,
    queryFn: passkeys.list,
    enabled: isPasskeysEnabled && auth.isAuthenticated(),
    staleTime: 30_000,
    retry: false,
  });
}

export function useRegisterPasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (name?: string) => passkeys.register(name),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: PASSKEYS_QUERY_KEY }),
  });
}

export function useRenamePasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, name }: { id: string; name: string }) =>
      passkeys.rename(id, name),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: PASSKEYS_QUERY_KEY }),
  });
}

export function useRemovePasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => passkeys.remove(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: PASSKEYS_QUERY_KEY }),
  });
}
